export default __webpack_public_path__ + "static/media/robot-regular.8fbca2e1.png";